// extracted by mini-css-extract-plugin
module.exports = {"tip":"tip_tip__Lt2cC"};